import { Show } from '@bygghemmait/components';
import cn from 'classnames';
import { Button } from 'components/Button';
import { IconArrow } from 'components/Shared/Icon';
import { isSameDay, isSameMonth, isWeekend } from 'date-fns';
import { getMonthName, isRangeWithinInterval, rm } from 'utils';
import { Day } from './Day';
import styles from './styles.scss';

interface OwnProps {
  rangeStartDate: Date;
  rangeEndDate: Date;
  daysToDisplay: Date[];
  todaysDate: Date;
  currentMonth: Date;
  selectDate: (date: Date) => void;
  selectedDate?: Date;
  browseCalendar?: boolean;
  className?: string;
  stepNext?: () => void;
  stepPrev?: () => void;
  shouldDisableWeekends?: boolean;
}

const dayNames = [
  'datepicker_mon',
  'datepicker_tue',
  'datepicker_wed',
  'datepicker_thu',
  'datepicker_fri',
  'datepicker_sat',
  'datepicker_sun'
];

export const DatePicker = ({
  rangeStartDate,
  rangeEndDate,
  selectedDate,
  currentMonth,
  daysToDisplay,
  className,
  selectDate,
  stepNext,
  stepPrev,
  todaysDate,
  browseCalendar = false,
  shouldDisableWeekends = false
}: OwnProps) => {
  const selected = selectedDate && new Date(selectedDate);

  return (
    <div className={cn(styles.datePicker, className)}>
      <div className={styles.pager}>
        <Show when={browseCalendar}>
          <Button appearance="tertiary" size="small" onClick={stepPrev} className={styles.navBtn}>
            <IconArrow thickness="thin" className={styles.icon} appearance="flip-180" />
          </Button>
        </Show>
        <div className={styles.month}>{getMonthName(currentMonth.getMonth())}</div>
        <Show when={browseCalendar}>
          <Button appearance="tertiary" size="small" onClick={stepNext} className={styles.navBtn}>
            <IconArrow thickness="thin" className={styles.icon} />
          </Button>
        </Show>
      </div>
      <div>
        {dayNames.map(day => (
          <span key={day} className={cn(styles.day, styles.dayTitle)}>
            {rm(day)}
          </span>
        ))}
        {daysToDisplay.map((day: Date) => {
          const key = `${day.getMonth()}${day.getDate()}`;
          const isCurrentMonth = isSameMonth(day, currentMonth);
          const currentDay = isSameDay(day, todaysDate);
          const dateInRange = isRangeWithinInterval(day, rangeStartDate, rangeEndDate);
          const isDayWeekend = isWeekend(day);

          return (
            <Day
              key={key}
              currentDay={currentDay}
              currentMonth={isCurrentMonth}
              browseCalendar={browseCalendar}
              day={day}
              selectDate={selectDate}
              dateInRange={dateInRange}
              showIsDaySelected={selected && isSameDay(selected, day)}
              isDayWeekend={isDayWeekend}
              shouldDisableWeekends={shouldDisableWeekends}
            />
          );
        })}
      </div>
    </div>
  );
};
